import {RELOAD_COMMON_STUDIO, reloadCommonStudioFailureAction, reloadCommonStudioSuccessAction} from "../commonActions";
import {getArtistToken} from "../../auth/token.saga";
import {extractDataFromResponse} from "../../saga-utils/httpInterceptorWrapper";
import {getStudio} from "../../../api/commonApi";
import {emitNotificationAction} from "../../notification/notificationAction";
import {createErrorNotification} from "../../../models/notification";
import i18next from "i18next";
import {i18_TRANSLATION} from "../../../i18nReferences";
import {call, put, takeLatest} from "redux-saga/effects"

function* processReloadStudio() {
    try {
        const token = yield getArtistToken()
        if (token) {
            const artistMap = extractDataFromResponse(yield call(getStudio, {token}))
            yield put(reloadCommonStudioSuccessAction(artistMap))
        }
    } catch (err) {
        console.log(err)
        yield put(reloadCommonStudioFailureAction())
        yield put(emitNotificationAction(createErrorNotification(i18next.t('COMMON.LOAD_STUDIO_DATA_FAILED_INFO', {ns: i18_TRANSLATION}), 'loadCommon')))
    }
}

export function* watchReloadStudio() {
    yield takeLatest([RELOAD_COMMON_STUDIO], processReloadStudio)
}